module.exports = __webpack_public_path__ + "img/img14.70fb0a2b.png";